import React, { useCallback, useMemo } from 'react';

import { DocumentCopyIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

const ActionMenu = ({
  anchorEl,
  onClearAnchorElement,
  isGenerateReportDisabled = false,
  onGenerateReport = _.noop,
}) => {
  const onClickGenerateReport = useCallback(() => {
    onClearAnchorElement();

    onGenerateReport();
  }, [onClearAnchorElement, onGenerateReport]);

  const items = useMemo(
    () => [
      {
        text: 'Generate New Report',
        onClick: onClickGenerateReport,
        icon: <DocumentCopyIcon size={IconSize[20]} />,
        isDisabled: isGenerateReportDisabled,
      },
    ],
    [onClickGenerateReport, isGenerateReportDisabled],
  );

  return (
    <MenuPopoverCDS
      anchorEl={anchorEl}
      data-testid={UnderwritingTestIds.UW_REPORTS_ACTION_MENU}
      items={items}
      onClose={onClearAnchorElement}
    />
  );
};

ActionMenu.propTypes = {
  isGenerateReportDisabled: PropTypes.bool,
  anchorEl: PropTypes.object,
  onClearAnchorElement: PropTypes.func,
  onGenerateReport: PropTypes.func,
};

export default ActionMenu;
